import { render, staticRenderFns } from "./ConfirmDeleteButton.vue?vue&type=template&id=2c3dfacd&scoped=true"
import script from "./ConfirmDeleteButton.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteButton.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeleteButton.vue?vue&type=style&index=0&id=2c3dfacd&prod&lang=scss"
import style1 from "./ConfirmDeleteButton.vue?vue&type=style&index=1&id=2c3dfacd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dfacd",
  null
  
)

export default component.exports